<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>گواهینامه</h2>
            </div>
        </div>
        <!-- end main title -->

        <!-- form -->
        <div class="col-12">
            <div class="form">
                <div class="row">


                    <div class="col-8 col-md-8 ">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="name" type="text" class="form__input" placeholder="نام گواهینامه">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 col-md-4 ">
                        <div class="form__group">
                            <ImageSelector label="تصویر"
                                           v-model:previewImage="file_preview"
                                           @imagefile="(n) => file = n"
                            />

                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row" v-for="(cert_item,index) in certificates">
                            <div class="col-4">
                                <input v-model="cert_item.name" placeholder="نام"/>
                            </div>
                            <div class="col-4">
                                <input v-model="cert_item.value" placeholder="مقدار"/>
                            </div>
                            <div class="col-2">
                                <button style="background: white;color:black;padding: 10px;" @click="certificates.push({name:'',value:''})">+</button>
                                <button style="background: white;color:black;padding: 10px;" @click="certificates.splice(index,1)" v-if="certificates.length>1">-</button>
                            </div>
                        </div>
                    </div>


                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button type="button" class="form__btn" @click="insert_data">{{status_form ==0 ?
                                    'افزودن' : 'ویرایش'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";
    import ImageSelector from "@/views/CustomComponent/ImageSelector";

    export default {
        name: 'Country',
        data() {
            return {
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'name', label: 'نام'},
                    {key: 'image', label: 'تصویر'},
                    {key: 'operation', label: 'عملیات'}
                ],
                status_form: 0,
                name: '',
                bio: '',
                file: null,
                file_preview: '',
                cover_file: null,
                cover_file_preview: '',
                certificates: [{name: '', value: ''}],

            }
        },
        components: {
            Datatable,
            ImageSelector
        },
        mounted() {
            this.get_data();
        },
        methods: {
            edit_item(item) {
                this.name = item.name;
                this.bio = item.summary;
                this.file_preview = item.image;
                this.status_form = item.id;
                this.file = null
            },
            get_data() {

                var self = this;

                var formData = new FormData();
                formData.append('poster_id', this.$route.params.movie_id);

                this.axios.post('get_item_certificate', formData, {}).then(function (response) {
                    var content_data = response.data;

                    // items = content_cats.orders;
                    if( content_data.name!=null){
                        self.status_form  = content_data.id
                        self.certificates = content_data.items
                        self.name = content_data.name
self.file_preview = content_data.image
                    }else{
                        self.status_form  = 0

                    }

                }).catch(function (error) {
                    console.log(error);
                });


            },
            insert_data() {

                var self = this;
                if (this.name == "") {
                    return
                }
                var formData = new FormData();
                var url = 'insert_item_certificate'
                formData.append('certificate', JSON.stringify(this.certificates));
                formData.append('file', this.file);
                formData.append('name', this.name);
                formData.append('poster_id', this.$route.params.movie_id);
                if (this.status_form != 0) {
                    formData.append('id', this.status_form);
                    url = 'update_item_certificate'
                }
                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data()
                    self.name = ''
                    self.bio = ''
                    self.file = null
                    self.status_form = 0;

                }).catch(function (error) {
                    console.log(error);
                });


            },
        }
    }
</script>

